import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { AppDispatch, RootState } from "store";
import { getCurrentUser } from "store/auth/actions";
import { selectUserPermission } from "store/auth/selector";
import {
  getAccount,
  getFactoringProfile,
  getInvitedGroups,
  getUserPermission
} from "store/user/actions";
import { selectUserDetails } from "store/user/selector";

const useCheckAccount = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { userToken, account } = useSelector((state: RootState) => state.authState);
  const userPermission = useSelector(selectUserPermission);
  const userDetails = useSelector(selectUserDetails);

  useEffect(() => {
    const fetchAccount = async () => {
      if (userToken && !account) await dispatch(getCurrentUser());
    };
    fetchAccount();
  }, [userToken, account, dispatch]);

  useEffect(() => {
    const fetchAccountDetails = async () => {
      if (account) {
        const userPromises: any[] = [];
        userPromises.push(dispatch(getAccount(account.id)));
        userPromises.push(dispatch(getUserPermission(account.id)));
        await Promise.all(userPromises);
      }
    };
    fetchAccountDetails();
  }, [account, dispatch]);

  useEffect(() => {
    const fetchInvitedGroups = async () => {
      if (account && userPermission) {
        const isInvitedCarrier = (userPermission?.user_type as string[]).find(
          (item) => item === "Invited Carrier"
        );
        if (isInvitedCarrier) await dispatch(getInvitedGroups("connected"));
      }
    };
    fetchInvitedGroups();
  }, [account, userPermission]);

  useEffect(() => {
    if (userDetails?.factoring_id) {
      dispatch(getFactoringProfile(userDetails.factoring_id));
    }
  }, [userDetails]);
};

export default useCheckAccount;
